import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { VideoRepository, VIDEO_REPOSITORY } from '@app/domain/repositories/multimedia/video/video.repository.contract';
import { PrivateVideo, Video } from '@app/entities/models/multimedia/video.model';

import { VideoUseCases } from './video.use-cases.contract';

@Injectable({
  providedIn: 'root'
})
export class VideoUseCasesImpl implements VideoUseCases {
  #videoRepository: VideoRepository = inject(VIDEO_REPOSITORY);

  getPrivateVideo(key: string): Observable<PrivateVideo> {
    return this.#videoRepository.getPrivateVideo(key);
  }

  getPublicVideo(key: string): Observable<Video> {
    return this.#videoRepository.getPublicVideo(key);
  }
}
